import { useCallback } from 'react';
import { useFlagsService, type FlagConfiguration } from '@atlassian/jira-flags';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { MutationError } from '@atlassian/jira-mutation-error/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
import messages from './messages.tsx';

const FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.defaultErrorTitle,
	description: messages.defaultErrorMessage,
	messageId:
		'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
	messageType: 'transactional',
};

export function useHandleError() {
	const { showFlag } = useFlagsService();

	const handleError = useCallback(
		(error: MutationError) => {
			fireErrorAnalytics({
				meta: {
					id: 'useUpdateFavouriteOrder',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			showFlag(FLAG);
		},
		[showFlag],
	);

	return handleError;
}
